import { Model, UserModel } from '@kaiser-software/chassis-core';
import { LocationModel } from '@kaiser-software/donna-core';
import { CategoryModel } from './category.model';

export class ObservationModel extends Model {

    protected statuses: { [key: string]: string };

    protected status = 'concept';

    public status_value: string;

    public created_at: string;

    public updated_at: string;

    public location: LocationModel;

    public account: any;

    public tenant: any;

    public category: CategoryModel;

    public account_id: number;

    public user_id: number;

    public user: UserModel;

    public urgent: boolean;

    public getStatus(): string {
        return this.status
            || 'concept';
    }

    public getStatusColor(): string {
        const status = this.getStatus();

        switch (status) {
            case 'completed':
                return 'success';
            default:
                return 'default';
        }
    }

    public getStatusText(): string {
        return this.status_value
            || 'Concept';
    }

    public isUrgent(): boolean {
        return !!(this.category && this.category.urgent);
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/models/observation.model.ts